module.exports = __webpack_public_path__ + "img/img_c_start_02.aeba3063.svg";